import React, { Component } from "react";
import Header from "../Shared/Header";
import IconInput from "../Shared/IconInput";
import SuccessAlert from "../Shared/SuccessAlert";
import ResetPasswordService from "./ResetPassword.service";
import "./ResetPassword.scss";
import pwd from "../../assets/image/icon/password black.png";
export default class ResetPassword extends Component {
    state = {
        email: undefined,
        password: undefined,
        passwordIsInvalid: false,
        passwordConfirmation: undefined,
        passwordConfirmationIsInvalid: false,
        code: undefined,
        codeIsInvalid: false,
        success: false,
        isLoading: false
    };

    goToLogin = () => {
        this.props.history.push("/login");
    };

    resetPassword = () => {
        if (
            !this.state.password ||
            this.state.passwordIsInvalid ||
            !this.state.passwordConfirmation ||
            this.state.passwordConfirmationIsInvalid ||
            !this.state.code ||
            this.state.codeIsInvalid
        ) {
            let newState = {};
            if (!this.state.password)
                newState.passwordIsInvalid = "This field is required.";
            if (!this.state.passwordConfirmation)
                newState.passwordConfirmationIsInvalid = "This field is required.";
            if (!this.state.code)
                newState.codeIsInvalid = "This field is required.";
            this.setState(newState);
            return;
        }

        this.setState({
            isLoading: true
        });

        ResetPasswordService.resetPassword(
            this.state.email,
            this.state.password,
            this.state.code
        )
            .then(response => {
                this.setState({
                    success: true
                });
            })
            .catch(error => {
                this.props.alert({
                    theme: "error",
                    message: error.message
                });
                this.setState({
                    isLoading: false
                });
            });
    };

    onKeyPress = e => {
        if (e.key === "Enter") {
            this.resetPassword();
        }
    };

    onNewPasswordValue = e => {
        if (this.state.passwordIsInvalid)
            this.setState({
                passwordIsInvalid: false
            });

        this.setState({
            password: e.target.value
        });

        if (e.target.value.length < 8) {
            this.setState({
                passwordIsInvalid: 'Password should have at least 8 characters.'
            });
        }
    };

    onNewPasswordConfirmationValue = e => {
        if (this.state.passwordConfirmationIsInvalid)
            this.setState({
                passwordConfirmationIsInvalid: false
            });

        this.setState({
            passwordConfirmation: e.target.value
        });

        if (this.state.password !== e.target.value) {
            this.setState({
                passwordConfirmationIsInvalid: 'Password confirmation should match.'
            });
        }
    };

    onNewCodeValue = e => {
        if (this.state.codeIsInvalid)
            this.setState({
                codeIsInvalid: false
            });

        this.setState({
            code: e.target.value
        });
    };

    componentDidMount() {
        const queryParams = new URLSearchParams(window.location.search);
        this.setState({
            email: queryParams.get('email')
        });
    }

    render() {

        return (
            <div>
                <Header />
                <div className="login d-flex justify-content-center align-items-center">
                    <div className="position-relative login-box d-flex flex-column justify-content-center align-items-center">
                        {this.state.success ? (
                            <SuccessAlert message="Password restablished!">
                                <button
                                    className="btn btn-outline-light mt-3"
                                    onClick={this.goToLogin}
                                >
                                    Log In
                                </button>
                                
                                <p className="helper-lg">Or login on any other devise.</p>
                            </SuccessAlert>
                        ) : (
                            ""
                        )}
                        <div className="d-flex w-100 align-items-center mb-3">
                            <h1 className="ml-2">Reset Password</h1>
                        </div>
                        <IconInput
                            isInvalid={this.state.passwordIsInvalid}
                            onValueChange={this.onNewPasswordValue}
                            onKeyPress={this.onKeyPress}
                            icon={pwd}
                            type="password"
                            placeholder="Password"
                        />
                        <IconInput
                            isInvalid={this.state.passwordConfirmationIsInvalid}
                            onValueChange={this.onNewPasswordConfirmationValue}
                            onKeyPress={this.onKeyPress}
                            icon={pwd}
                            type="password"
                            placeholder="Confirm Password"
                        />
                        <IconInput
                            isInvalid={this.state.codeIsInvalid}
                            onValueChange={this.onNewCodeValue}
                            onKeyPress={this.onKeyPress}
                            icon={pwd}
                            type="number"
                            placeholder="Code"
                        />
                        <button
                            type="button"
                            className="btn btn-primary mt-1 mb-2 w-100 btn-signup"
                            onClick={this.resetPassword}
                            disabled={this.state.isLoading}
                        >
                            {this.state.isLoading ? (
                                <div
                                    id="btn-login-spinner"
                                    className="spinner-border spinner-border-sm text-light"
                                    role="status"
                                >
                                    <span className="sr-only">Loading...</span>
                                </div>
                            ) : (
                                "Submit"
                            )}
                        </button>
                        <a href="login">Cancel</a>
                    </div>
                </div>
            </div>
        );
    }
}
